import {call, put, takeEvery} from "redux-saga/effects"
import { GET_SERVICECITY, GET_SERVICEREGION, GET_SUBVENDORREGION } from "resources/actionTypes"
import { serviceCityApi, serviceRegionApi, subVendorRegionApi } from "services/ServiceCityService"

function* fetchServiceCity(action) {
  try {
    const payload = action.payload || {}
    const userServiceCity = yield call(serviceCityApi,payload);

    yield put({ type: GET_SERVICECITY.GET_SERVICECITY_SUCCESS, userServiceCity: userServiceCity });
  } catch (e) {
    yield put({ type: GET_SERVICECITY.GET_SERVICECITY_FAILED, message: e.message });
  }
}

export function* serviceCitySaga() {
  yield takeEvery(GET_SERVICECITY.GET_SERVICECITY_REQUESTED, fetchServiceCity);
}

function* fetchServiceRegion(action) {
  try {
    const payload = action.payload || {}
    const userServiceRegion = yield call(serviceRegionApi,payload);
    yield put({ type: GET_SERVICEREGION.GET_SERVICEREGION_SUCCESS, userServiceRegion: userServiceRegion });
  } catch (e) {
    yield put({ type: GET_SERVICEREGION.GET_SERVICEREGION_FAILED, message: e.message });
  }
}

export function* serviceRegionSaga() {
  yield takeEvery(GET_SERVICEREGION.GET_SERVICEREGION_REQUESTED, fetchServiceRegion);
}

function* fetchSubVendorRegion(action) {
  try {
    const payload = action.payload || {}
    const userSubVendorRegion = yield call(subVendorRegionApi,payload);
    yield put({ type: GET_SUBVENDORREGION.GET_SUBVENDORREGION_SUCCESS, userSubVendorRegion: userSubVendorRegion });
  } catch (e) {
    yield put({ type: GET_SUBVENDORREGION.GET_SUBVENDORREGION_FAILED, message: e.message });
  }
}

export function* serviceSubVendorRegionSaga() {
  yield takeEvery(GET_SUBVENDORREGION.GET_SUBVENDORREGION_REQUESTED, fetchSubVendorRegion);
}